module.exports = __webpack_public_path__ + "img/6-1_02.00026ae3.jpg";